import { useEffect, useRef, useState } from 'react';

const differentiators = [
  {
    num: '01',
    icon: 'ri-links-line',
    title: '팩·라벨·부착 원스톱',
    desc: '별도 업체를 여러 군데 알아볼 필요 없습니다. 패키지, 라벨 디자인, 부착 서비스를 한 곳에서 해결합니다.',
  },
  {
    num: '02',
    icon: 'ri-truck-line',
    title: '바로 판매 가능한 상태로 납품',
    desc: '받는 즉시 판매대에 올릴 수 있도록 라벨 부착까지 완료된 상태로 출고합니다. 농가의 포장 작업 부담을 줄여드립니다.',
  },
  {
    num: '03',
    icon: 'ri-leaf-line',
    title: '농산물 특화 패키징',
    desc: '토마토, 블루베리, 딸기 등 다양한 과일 특성을 고려한 최적의 패키징 솔루션을 제공합니다.',
  },
];

export default function DifferentiatorsSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="differentiators" ref={ref} className="py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, #0A508C 0%, #3A7CC0 40%, #2BC0D0 75%, #70C6A3 100%)' }} />
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, white 1px, transparent 1px), radial-gradient(circle at 80% 80%, white 1px, transparent 1px)', backgroundSize: '60px 60px' }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className={`text-center mb-14 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <div className="text-sm font-bold uppercase tracking-widest mb-3 text-white/60">WHY XINJIN</div>
          <h2 className="text-4xl font-black text-white mb-3">왜 신진패키징인가요?</h2>
          <p className="text-white/70 text-base">농산물 패키징 실무의 번거로움을 해결해드립니다</p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {differentiators.map((d, i) => (
            <div
              key={d.num}
              className={`rounded-2xl p-7 transition-all duration-700 hover:-translate-y-1 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{
                transitionDelay: `${i * 120}ms`,
                background: 'rgba(255,255,255,0.12)',
                border: '1px solid rgba(255,255,255,0.2)',
              }}
            >
              {/* Number */}
              <div className="text-6xl font-black mb-4 leading-none" style={{ color: 'rgba(255,255,255,0.18)' }}>{d.num}</div>

              {/* Icon */}
              <div className="w-12 h-12 flex items-center justify-center rounded-xl mb-4 bg-white/20">
                <i className={`${d.icon} text-white text-xl`} />
              </div>

              {/* Content */}
              <h3 className="text-lg font-black text-white mb-3">{d.title}</h3>
              <p className="text-white/70 text-base leading-relaxed">{d.desc}</p>
            </div>
          ))}
        </div>

        {/* Extra Stats Row */}
        <div
          className={`mt-10 grid grid-cols-2 md:grid-cols-4 gap-4 transition-all duration-700 delay-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          {[
            { num: '10+', label: '운영 연수' },
            { num: '300+', label: '납품 농가·기관' },
            { num: '15+', label: '취급 품목 수' },
            { num: '1일', label: '최단 납기일' },
          ].map((stat) => (
            <div key={stat.label} className="text-center py-5 rounded-xl" style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.15)' }}>
              <div className="text-3xl font-black text-white">{stat.num}</div>
              <div className="text-sm text-white/60 mt-1.5 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
